// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2KbVr","unreadBadge":"styles_unreadBadge__2k6cp","modalContent":"styles_modalContent__3WlcN","modal":"styles_modal__1Qd8T"};